import useIntl from '../../../hooks/useIntl';
import messages from './messages';
// eslint-disable-next-line max-len
import type { Header } from '@fortress-technology-solutions/fortress-component-library/Organisms_Fortress/Table/Table.types';
import useUniqueTableName from '../../../hooks/useUniqueTableName';
import { useReportHistoryQuery } from './hooks.query';
import useSelectedProperty from '../../../hooks/useSelectedProperty';
import {
  useTableFilterSortData,
  useTableFilterSortSearchManager,
} from '@fortress-technology-solutions/fortress-component-library/Organisms_Fortress';
import { PROPERTY_PATH_MAP } from './constants';
import useRows from './hooks.useRows';
import RentForecastService from './../../../services/rentForecastService';

export const useReportHistoryTable = (rentForecastId: string) => {
  const intl = useIntl();
  const property = useSelectedProperty();
  const tableName = useUniqueTableName(
    `rent-forecast-report-history-${rentForecastId}`,
  );

  const headers: Header[] = [
    {
      id: 'source',
      label: intl.formatMessage(messages.reportHistoryHeaderSource),
    },
    {
      id: 'date',
      label: intl.formatMessage(messages.reportHistoryHeaderDate),
      sortable: true,
    },
    {
      id: 'download',
      label: intl.formatMessage(messages.reportHistoryHeaderDownload),
    },
  ];
  const { data, refetch } = useReportHistoryQuery(
    property.organizationId,
    property.id,
    rentForecastId,
  );
  const {
    order,
    orderBy,
    filterState,
    filterTypeState,
    searchState,
    dateState,
  } = useTableFilterSortSearchManager({
    name: tableName,
    headers,
  });
  const sortedAndFilteredResults = useTableFilterSortData({
    results: data,
    order,
    orderBy,
    filterState,
    filterTypeState,
    searchState,
    dateState,
    PROPERTY_PATH_MAP,
  });

  const onDownloadClick = (id: string) => {
    const rentForecastService = new RentForecastService();

    return Promise.all([
      rentForecastService.downloadReport(
        property.organizationId,
        property.id,
        rentForecastId,
        id,
        'pdf',
      ),
      rentForecastService.downloadReport(
        property.organizationId,
        property.id,
        rentForecastId,
        id,
        'xml',
      ),
    ]);
  };

  const rows = useRows(sortedAndFilteredResults, onDownloadClick);

  return {
    headers,
    tableName,
    rows,
    count: rows.length ?? 0,
    totalCount: data.length ?? 0,
    refetch,
  };
};
